/*
 *
 * Workspace admin reducers
 *
 */

import keyBy from 'lodash/keyBy';
import { fromJS } from 'immutable';
import * as constants from './constants';

const initialAccountsState = fromJS({
  accounts: null,
});

const initialTeamsState = fromJS({
  teams: null,
  team: {},
});

function workspaceAccountReducer(state = initialAccountsState, action) {
  switch (action.type) {
    case constants.ADD_ACCOUNT: {
      const { account } = action;
      const accountById = {
        [account.accountId]: account,
      };

      return getUpdatedStateWithAccount(state, accountById);
    }
    case constants.ADD_ACCOUNTS_LIST: {
      const { accounts } = action;
      const accountsById = keyBy(accounts, 'accountId');

      return state.setIn(['accounts'], accountsById);
    }
    default:
      return state;
  }
}

const workspaceTeamsReducer = (state = initialTeamsState, action) => {
  switch (action.type) {
    case constants.SET_TEAM_LIST:
      return state.setIn(['teams'], action.teams);
    case constants.SET_TEAM_ACCOUNTS:
      return getUpdatedStateWithTeam(state, action.teamId, { accounts: action.accounts });
    default:
      return state;
  }
};

const initialWorkspacesState = fromJS({
  workspaces: undefined,
  workspace: {},
  loading: undefined,
});

const workspaceWorkspacesReducer = (state = initialWorkspacesState, action) => {
  switch (action.type) {
    case constants.ADD_WORKSPACES_LIST:
      return state.setIn(['workspaces'], action.workspaces);
    case constants.ADD_WORKSPACE: {
      const { workspace } = action;

      return getUpdatedStateWithWorkspace(state, workspace);
    }
    case constants.SET_WORKSPACE_COLLABORATORS:
      return state.updateIn(['workspace', action.workspaceId], (item) => ({
        ...item,
        collaborators: action.collaborators,
      }));
    case constants.WORKSPACE_LOADING:
      return state.setIn(['loading'], action.loading);
    case constants.SET_SELECTED_WORKSPACE:
      return state.set('selectedWorkspace', action.selectedWorkspace);
    default:
      return state;
  }
};

const getUpdatedStateWithTeam = (state, teamId, teamToUpdate) => {
  const existingTeam = state.getIn(['team', teamId]);
  const updatedTeam = { ...existingTeam, ...teamToUpdate };
  return state.setIn(['team', teamId], updatedTeam);
};

export const getUpdatedStateWithAccount = (state, accountToUpdate) => {
  const existingAccount = state.getIn(['accounts']);
  const updatedAccount = { ...existingAccount, ...accountToUpdate };

  return state.setIn(['accounts'], updatedAccount);
};

export const getUpdatedStateWithWorkspace = (state, workspaceToUpdate) => {
  const existingWorkspaces = state.getIn(['workspaces']) || [];
  const updatedWorkspace = [...existingWorkspaces, workspaceToUpdate];

  return state.setIn(['workspaces'], updatedWorkspace);
};

export default {
  workspaceAccounts: workspaceAccountReducer,
  workspaceTeams: workspaceTeamsReducer,
  workspaceWorkspaces: workspaceWorkspacesReducer,
};
